import { PermissionsGate } from '@/modules/auth/components/permissions/PermissionsGate';
import { permissions } from '@/modules/auth/permissions';
import {
  Button,
  type ButtonProps,
} from '@/modules/ui/components/button/Button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/modules/ui/components/tooltip/Tooltip';
import { useIsLinkedInConnected } from '@/modules/user-external-accounts/hooks/useIsLinkedInConnected';

import { ConnectAccountTooltlip } from './ConnectAccountTooltlip';

interface GatedReachOutButtonProps extends ButtonProps {
  isPending: boolean;
}

export const GatedReachOutButton = (props: GatedReachOutButtonProps) => {
  return (
    <PermissionsGate permissions={[permissions.Messaging.Write]}>
      <GatedReachOutButtonInner {...props} />
    </PermissionsGate>
  );
};

const GatedReachOutButtonInner = ({
  isPending,
  ...props
}: GatedReachOutButtonProps) => {
  const { isLinkedInConnected, userId } = useIsLinkedInConnected();

  if (!isLinkedInConnected) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <Button {...props} disabled loading={isPending}>
              {props.children}
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <ConnectAccountTooltlip userId={userId} />
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Button
      {...props}
      loading={isPending}
      disabled={props.disabled || isPending}
    >
      {props.children}
    </Button>
  );
};
